module.exports = __webpack_public_path__ + "img/norton-home-loans.87266cb8.jpg";